import { useState } from 'react';
import PropTypes from 'prop-types';

import UserImage from './UserImage/UserImage';
import MyDegree from 'uI/MyDegree/MyDegree';
import PersonalInfo from './PersonalInfo/PersonalInfo';

import classes from './Profile.module.css';

const Profile = props => {
  const [name, setName] = useState(props.userData.nombre);
  const [lastName, setLastName] = useState(props.userData.apellido);

  const changeNameHandler = (param, value) => {
    if (param === 'name') {
      setName(value);
    } else {
      setLastName(value);
    }
  };

  return (
    <>
      <aside className={classes.descriptionSection}>
        <p className={classes.title}>Mi Perfil</p>
        <p className={classes.subtitle}>
          Completa y edita tu información
        </p>
      </aside>
      <aside className={classes.userDataContainer}>
        <UserImage userImage={props.userData.url} />
        <PersonalInfo
          userData={props.userData}
          changeName={changeNameHandler}
        />
      </aside>
      <MyDegree
        demoProfile
        userData={props.userData}
        name={name}
        lastName={lastName}
      />
    </>
  );
};

Profile.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userData: PropTypes.array
};

export default Profile;
